export default __webpack_public_path__ + "static/media/sidebar-6.95db1f69.svg";